<template>
  <el-dialog
    :visible="visible"
    :before-close="handleClose"
    custom-class="bg-state-container"
    :title="'本底状态' | translateTo('layout')"
  >
    <el-button class="clear-bg-btn" @click="clearBground" size="mini" type="primary">
      {{ '清除本底' | translateTo('layout') }}
    </el-button>
    <el-table :data="tableProps" height="55vh">
      <el-table-column :label="'检测项' | translateTo('layout')" prop="item">
        <template #default="{ row }">
          {{ row.item | translateTo('layout') }}
        </template>
      </el-table-column>
      <el-table-column :label="'实时值' | translateTo('layout')" prop="realVal">
        <template #default="{ row }">
          {{ getData(row.mod, row.realVal) }}
        </template>
      </el-table-column>
      <el-table-column :label="'本底值' | translateTo('layout')" prop="bgVal">
        <template #default="{ row }">
          {{ getData(row.mod, row.bgVal) }}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getTableOption } from '../utils/bgStateDict';
import { mapState } from 'vuex';
import { clearBground } from '@/api/devices';

export default {
  props: {
    sn: [String, null, undefined],
    deviceType: [String, null, undefined],
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('socket', ['singleDeviceDetail']),
    tableProps() {
      if (!this.deviceType || !this.singleDeviceDetail.mods) return [];
      const mods = Object.keys(this.singleDeviceDetail.mods);
      if (!mods) return [];
      return getTableOption(this.deviceType, mods);
    }
  },
  methods: {
    getData(mod, prop) {
      const { mods } = this.singleDeviceDetail;
      if (!mods) return '_';
      mod = mod.toLowerCase() + 'Mod';
      mod = mods[mod];
      if (!mod) return '_';
      if (typeof prop === 'function') return prop(mod);
      return mod[prop] || '_';
    },
    handleClose(done) {
      this.$emit('update:visible', false);
      done();
    },
    clearBground() {
      clearBground({ sn: this.sn, deviceType: this.deviceType }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.bg-state-container {
  .clear-bg-btn {
    margin-bottom: 18px;
  }
}
</style>
